/**
 * Centralized URL configuration for the website package.
 * Never inline URLs - always use these constants.
 */

// App URLs - where to redirect users for authentication and app features
export const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.pcnguard.co.uk';

// Website URLs (self-referential, used for sharing/canonical links)
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL || 'https://pcnguard.co.uk';

// Mobile app store URLs
const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=uk.co.pcnguard.app';
const ANDROID_PACKAGE_NAME = import.meta.env.VITE_ANDROID_PACKAGE_NAME || '';

// Helper functions for common app links
export const getAppLoginUrl = () => `${APP_URL}/#/login`;
export const getAppSignupUrl = () => `${APP_URL}/#/signup`;
export const getAppDashboardUrl = () => `${APP_URL}/#/dashboard`;
export const getAppPricingUrl = () => `${APP_URL}/#/pricing`;
export const getFleetTrialSignupUrl = () => `${APP_URL}/#/signup?product=fleetmode&trial=3pcn-ai-control&duration=7d&source=fleetpage`;
export const getFleetDemoUrl = () => import.meta.env.VITE_FLEET_DEMO_URL || '/fleet/demo';

export const getPlayStoreUrl = () => {
  if (PLAY_STORE_URL) return PLAY_STORE_URL;
  if (ANDROID_PACKAGE_NAME) {
    return `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`;
  }
  return '';
};

